// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"77dcc1de56ad322d30f0","655":"b9039dd2c7413e716333"}[chunkId] + ".js";
};